import { apiSlice, getApiBaseUrl } from "./apiSlice";

const API_BASE = getApiBaseUrl();

const USERS_URL = `${API_BASE}/users`
const SUPERDISTRIBUTOR_LIST = `${API_BASE}/superdistributor`
const DISTRIBUTOR_LIST = `${API_BASE}/distributor`
const RETAILER_LIST = `${API_BASE}/retailer`
const DASHBOARD = `${API_BASE}/dashboard`
const PAYMENTS = `${API_BASE}/payments`
const RAZOR = `${API_BASE}/razor`
const CASHFREE = `${API_BASE}/cashfree`
const Contact = `${API_BASE}/contact`
const Services = `${API_BASE}/services`
const GST = `${API_BASE}/gst`
const REPORTER = `${API_BASE}/reporter`
const USER_MANAGEMENT = `${API_BASE}/user-management`
const COMMISSIONS = `${API_BASE}/commissions`
const INVITATIONS = `${API_BASE}/invitations`
const PERMISSIONS = `${API_BASE}/permissions`
const ADMIN_PERMISSIONS = `${API_BASE}/admin/permissions`
const QR_PG = `${API_BASE}/qr-pg`
const ADMIN_QR_PG = `${API_BASE}/admin/qr-pg`
const SETTLEMENTS = `${API_BASE}/settlements`
const NOTIFICATIONS = `${API_BASE}/notifications`
const SETTINGS = `${API_BASE}/settings`
const CARD_TO_BANK = `${API_BASE}/card-to-bank`
export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints:(builder)=>({
        checkUser:builder.mutation({
            query:(data)=>({
                    url:`${USERS_URL}/check-user`,
                    method:"POST",
                    body:data
            })
        }),
        setPassword:builder.mutation({
            query:(data)=>({
                    url:`${USERS_URL}/set-password`,
                    method:"POST",
                    body:data
            })
        }),
        resetPasswordWithFirebase:builder.mutation({
            query:(data)=>({
                    url:`${USERS_URL}/reset-password`,
                    method:"POST",
                    body:data
            })
        }),
        login:builder.mutation({
            query:(data)=>({
                    url:`${USERS_URL}/auth`,
                    method:"POST",
                    body:data
            })
        }),
        accepTerms:builder.mutation({
            query:()=>({
                url:`${USERS_URL}/terms`,
                method:'PUT',

            })
        }),
        logout:builder.mutation({
            query:()=>({
                url:`${USERS_URL}/logout`,
                method:"POST",

            })
        }),
        refreshSession:builder.mutation({
            query:()=>({
                url:`${USERS_URL}/refresh-session`,
                method:"POST",
            })
        }),
        getSessionConfig:builder.query({
            query:()=>({
                url:`${USERS_URL}/session-config`,
                method:"GET",
            })
        }),
        updateUser:builder.mutation({
            query:(data)=>({
                url:`${USERS_URL}/profile`,
                method:'PUT',
                body:data
            }),
            invalidatesTags:['UserProfile']
        }),
        changePassword:builder.mutation({
            query:(data)=>({
                url:`${USERS_URL}/change-password`,
                method:'PUT',
                body:data
            }),
            invalidatesTags:['UserProfile']
        }),
        getUser:builder.query({
            query:()=>({
                url:`${USERS_URL}/profile`,
                method:'GET'
            }),
            providesTags:['UserProfile']
        }),
        createUser:builder.mutation({
            query:(data)=>({
                url:`${USERS_URL}/`,
                method:'POST',
                body:data
            })
        }),
        getSuperDistributor:builder.mutation({
            query:()=>({
                url:`${SUPERDISTRIBUTOR_LIST}/profile`,
                method:'GET',
            })
        }),
        createSuperDistributor:builder.mutation({
            query:(data)=>({
                url:`${SUPERDISTRIBUTOR_LIST}/register`,
                method:'POST',
                body:data
            })
        }),
        getSuperDistributorDetails:builder.mutation({
            query:(data)=>({
                url:`${SUPERDISTRIBUTOR_LIST}/profile/id`,
                method:'POST',
                body:data
            })
        }),
        updateSuperDistributor:builder.mutation({
            query:(data)=>({
                url:`${SUPERDISTRIBUTOR_LIST}/profile`,
                method:'PUT',
                body:data
            })
        }),
        approveSuperDistributor:builder.mutation({
            query:(data)=>({
                url:`${SUPERDISTRIBUTOR_LIST}/approve`,
                method:'POST',
                body:data
            })
        }),
        activateSuperDistributor:builder.mutation({
            query:(data)=>({
                url:`${SUPERDISTRIBUTOR_LIST}/status`,
                method:'PUT',
                body:data
            })
        }),
        getDistributor:builder.mutation({
            query:()=>({
                url:`${DISTRIBUTOR_LIST}/profile`,
                method:'GET',
            })
        }),
        createDistributor:builder.mutation({
            query:(data)=>({
                url:`${DISTRIBUTOR_LIST}/register`,
                method:'POST',
                body:data
            })
        }),
        getDistributorDetails:builder.mutation({
            query:(data)=>({
                url:`${DISTRIBUTOR_LIST}/profile/id`,
                method:'POST',
                body:data
            })
        }),
        updateDistributorMargin:builder.mutation({
            query:(data)=>({
                url:`${DISTRIBUTOR_LIST}/update`,
                method:'PUT',
                body:data
            })
        }),
        updateDistributor:builder.mutation({
            query:(data)=>({
                url:`${DISTRIBUTOR_LIST}/profile`,
                method:'PUT',
                body:data
            })
        }),
        approveDistributor:builder.mutation({
            query:(data)=>({
                url:`${DISTRIBUTOR_LIST}/approve`,
                method:'POST',
                body:data
            })
        }),
        activateDistributor:builder.mutation({
            query:(data)=>({
                url:`${DISTRIBUTOR_LIST}/status`,
                method:'PUT',
                body:data
            })
        }),
        createRetailer:builder.mutation({
            query:(data)=>({
                url:`${RETAILER_LIST}/register`,
                method:'POST',
                body:data
            })
        }),
        getRetailer:builder.mutation({
            query:(data)=>({
                url:`${RETAILER_LIST}/profile`,
                method:'POST',
                body:data
            })
        }),
        getRetailerDetails:builder.mutation({
            query:(data)=>({
                url:`${RETAILER_LIST}/profile/id`,
                method:'POST',
                body:data
            })
        }),

        updateRetailer:builder.mutation({
            query:(data)=>({
                url:`${RETAILER_LIST}/profile`,
                method:'PUT',
                body:data
            })
        }),
        approveRetailer:builder.mutation({
            query:(data)=>({
                url:`${RETAILER_LIST}/approve`,
                method:'POST',
                body:data
            })
        }),
        updateRetailerPercentage:builder.mutation({
            query:(data)=>({
                url:`${RETAILER_LIST}/update`,
                method:'PUT',
                body:data,
            })
        }),
        activeRetailer:builder.mutation({
            query:(data)=>({
                url:`${RETAILER_LIST}/status`,
                method:'PUT',
                body:data
            })
        }),
        createOrder:builder.mutation({
            query:(data)=>({
                url:`${PAYMENTS}`,
                method:"POST",
                body:data
            })
        }),
        orderStatus:builder.mutation({
            query:(data)=>({
                url:`${RAZOR}/payment-status`,
                method:'POST',
                body:data
            })
        }),
        orderHistory:builder.mutation({
            query:(data)=>({
                url:`${PAYMENTS}/orders`,
                method:'POST',
                body:data
            })
        }),
        retailer:builder.mutation({
            query:(data)=>({
                url:`${DASHBOARD}/retailer`,
                method:'POST',
                body:data
            })
        }),
        aadhar:builder.mutation({
            query:(data)=>({
                url:`${CASHFREE}/verify-aadhar`,
                method:'POST',
                body:data
            })
        }),
        otp:builder.mutation({
            query:(data)=>({
                url:`${CASHFREE}/verify-otp`,
                method:'POST',
                body:data
            })
        }),
        pan:builder.mutation({
            query:(data)=>({
                url:`${CASHFREE}/verify-pan`,
                method:'POST',
                body:data
            })
        }),
        contact:builder.mutation({
            query:(data)=>({
                url:`${Contact}/`,
                method:'POST',
                body:data
            })
        }),
        forgotPassword:builder.mutation({
            query:(data)=>({
                url:`${Services}/forgot-password`,
                method:'POST',
                body:data
            })
        }),
        verify:builder.mutation({
            query:(data)=>({
                url:`${Services}/verify`,
                method:'POST',
                body:data
            })
        }),
        resetPassword:builder.mutation({
            query:(data)=>({
                url:`${Services}/reset-password`,
                method:'POST',
                body:data
            })
        }),
        apiLock:builder.mutation({
            query:(data)=>({
                url:`${Services}/api-lock`,
                method:'POST',
                body:data
            })
        }),
        gst:builder.mutation({
            query:(data)=>({
                url:`${GST}`,
                method:'POST',
                body:data
            })
        }),
        getReporter:builder.mutation({
            query:()=>({
                url:`${REPORTER}/profile`,
                method:'GET'
            })
        }),
        createReporter:builder.mutation({
            query:(data)=>({
                url:`${REPORTER}/register`,
                method:"POST",
                body:data
            })
        }),
        getGateWays:builder.mutation({
            query:()=>({
                url:`${PAYMENTS}/gateway-charges`,
                method:"POST",
            })
        }),
        createGateWays:builder.mutation({
            query:(data)=>({
                url:`${PAYMENTS}/gateway-charges/create`,
                method:"POST",
                body:data
            })
        }),
        toggleGateWayStatus:builder.mutation({
            query:(id)=>({
                url:`${PAYMENTS}/gateway-charges/${id}/toggle`,
                method:"PUT"
            })
        }),
        updateGateWayConfig:builder.mutation({
            query:({ id, ...data })=>({
                url:`${PAYMENTS}/gateway-charges/${id}/config`,
                method:"PUT",
                body:data
            })
        }),
        deleteGateWay:builder.mutation({
            query:(id)=>({
                url:`${PAYMENTS}/gateway-charges/${id}`,
                method:"DELETE"
            })
        }),
        getUserManagementSummary:builder.query({
            query:()=>({
                url:`${USER_MANAGEMENT}/summary`,
                method:'GET'
            }),
            providesTags:['UserManagementSummary']
        }),
        getUserManagementList:builder.mutation({
            query:(filters)=>({
                url:`${USER_MANAGEMENT}/list`,
                method:'POST',
                body:filters
            })
        }),
        getUserManagementDetail:builder.query({
            query:(id)=>({
                url:`${USER_MANAGEMENT}/${id}/detail`,
                method:'GET'
            })
        }),
        getPotentialParents:builder.query({
            query:(arg)=>({
                url:`${USER_MANAGEMENT}/potential-parents?targetRole=${typeof arg === 'object' && arg !== null ? (arg.targetRole || '') : arg}`,
                method:'GET'
            })
        }),
        createUserInHierarchy:builder.mutation({
            query:(data)=>({
                url:`${USER_MANAGEMENT}/create`,
                method:'POST',
                body:data
            }),
            invalidatesTags:['UserManagementSummary']
        }),
        updateUserStatus:builder.mutation({
            query:({ id, status })=>({
                url:`${USER_MANAGEMENT}/${id}/status`,
                method:'PUT',
                body:{ status }
            }),
            invalidatesTags:['UserManagementSummary']
        }),
        editUserInHierarchy:builder.mutation({
            query:({ id, user_id, ...data })=>({
                url:`${USER_MANAGEMENT}/${id || user_id}/edit`,
                method:'PUT',
                body:{ user_id, ...data }
            }),
            invalidatesTags:['UserManagementSummary', 'Users']
        }),
        updateUserParent:builder.mutation({
            query:({ id, new_parent_id })=>({
                url:`${USER_MANAGEMENT}/${id}/parent`,
                method:'PUT',
                body:{ new_parent_id }
            }),
            invalidatesTags:['UserManagementSummary']
        }),
        adjustUserBalance:builder.mutation({
            query:({ id, amount, type, remarks })=>({
                url:`${USER_MANAGEMENT}/${id}/balance`,
                method:'POST',
                body:{ amount, type, remarks }
            }),
            invalidatesTags:['UserManagementSummary']
        }),
        resetUserPasswordInHierarchy:builder.mutation({
            query:({ id, new_password })=>({
                url:`${USER_MANAGEMENT}/${id}/reset-password`,
                method:'POST',
                body:{ new_password }
            })
        }),
        resetUserLoginCounter:builder.mutation({
            query:({ id })=>({
                url:`${USER_MANAGEMENT}/${id}/reset-login-counter`,
                method:'POST'
            })
        }),
        updateUserKycStatus:builder.mutation({
            query:({ id, kyc_status, remarks })=>({
                url:`${USER_MANAGEMENT}/${id}/kyc-status`,
                method:'PUT',
                body:{ kyc_status, remarks }
            }),
            invalidatesTags:['UserManagementSummary']
        }),
        toggleUserWalletStatus:builder.mutation({
            query:({ id, wallet_status, reason })=>({
                url:`${USER_MANAGEMENT}/${id}/wallet-status`,
                method:'PUT',
                body:{ wallet_status, reason }
            }),
            invalidatesTags:['UserManagementSummary', 'Users']
        }),
        getUserTransactions:builder.mutation({
            query:({ id, ...data })=>({
                url:`${USER_MANAGEMENT}/${id}/transactions`,
                method:'POST',
                body:data
            })
        }),
        getCommissionGateways:builder.query({
            query:()=>({
                url:`${COMMISSIONS}/gateways`,
                method:'GET'
            }),
            providesTags:['CommissionRules']
        }),
        getCommissionMembers:builder.query({
            query:()=>({
                url:`${COMMISSIONS}/members`,
                method:'GET'
            })
        }),
        getCommissionRules:builder.query({
            query:()=>({
                url:`${COMMISSIONS}/rules`,
                method:'GET'
            }),
            providesTags:['CommissionRules']
        }),
        updateCommissionRule:builder.mutation({
            query:({ gateway_code, ...data })=>({
                url:`${COMMISSIONS}/rules/${gateway_code}`,
                method:'PUT',
                body:data
            }),
            invalidatesTags:['CommissionRules', 'OverrideHistory']
        }),
        getUserOverride:builder.query({
            query:(args)=>{
                const userId = typeof args === 'object' ? args?.user_id : args;
                const gateway = typeof args === 'object' ? args?.gateway_code : 'ALL';
                return {
                    url:`${COMMISSIONS}/overrides/${userId}${gateway ? `?gateway_code=${gateway}` : ''}`,
                    method:'GET'
                };
            },
            providesTags:['UserOverrides']
        }),
        saveUserOverride:builder.mutation({
            query:(data)=>({
                url:`${COMMISSIONS}/overrides`,
                method:'POST',
                body:data
            }),
            invalidatesTags:['UserOverrides', 'OverrideHistory']
        }),
        getOverrideHistory:builder.query({
            query:(params)=>({
                url:`${COMMISSIONS}/history${params?.gateway_code ? `?gateway_code=${params.gateway_code}` : ''}`,
                method:'GET'
            }),
            providesTags:['OverrideHistory']
        }),
        restoreOverrideHistory:builder.mutation({
            query:(id)=>({
                url:`${COMMISSIONS}/history/${id}/restore`,
                method:'POST'
            }),
            invalidatesTags:['UserOverrides', 'OverrideHistory', 'CommissionRules']
        }),
        getTodayTransactions:builder.query({
            query:(params)=>{
                const qs = new URLSearchParams();
                if (params?.gateway && params.gateway !== 'ALL') qs.append('gateway', params.gateway);
                if (params?.role_id && params.role_id !== 'ALL') qs.append('role_id', params.role_id);
                if (params?.search) qs.append('search', params.search);
                if (params?.date_filter) qs.append('date_filter', params.date_filter);
                if (params?.startDate) qs.append('startDate', params.startDate);
                if (params?.endDate) qs.append('endDate', params.endDate);
                const queryString = qs.toString();
                return {
                    url:`${PAYMENTS}/today-transactions${queryString ? `?${queryString}` : ''}`,
                    method:'GET'
                };
            },
            providesTags:['TodayTransactions']
        }),
        sendInvitation:builder.mutation({
            query:(data)=>({
                url:`${INVITATIONS}/send`,
                method:'POST',
                body:data
            }),
            invalidatesTags:['Invitations', 'PendingApprovals']
        }),
        getMyInvitations:builder.query({
            query:(params)=>{
                const searchParams = new URLSearchParams();
                if (params?.page) searchParams.append('page', params.page);
                if (params?.limit) searchParams.append('limit', params.limit);
                if (params?.search) searchParams.append('search', params.search);
                if (params?.status) searchParams.append('status', params.status);
                if (params?.role_id) searchParams.append('role_id', params.role_id);
                if (params?.startDate) searchParams.append('startDate', params.startDate);
                if (params?.endDate) searchParams.append('endDate', params.endDate);
                const qs = searchParams.toString();
                return {
                    url:`${INVITATIONS}/my-invites${qs ? `?${qs}` : ''}`,
                    method:'GET'
                };
            },
            providesTags:['Invitations']
        }),
        resendInvitation:builder.mutation({
            query:(id)=>({
                url:`${INVITATIONS}/resend/${id}`,
                method:'POST'
            }),
            invalidatesTags:['Invitations']
        }),
        cancelInvitation:builder.mutation({
            query:(id)=>({
                url:`${INVITATIONS}/cancel/${id}`,
                method:'POST'
            }),
            invalidatesTags:['Invitations']
        }),
        getAllowedRoles:builder.query({
            query:()=>({
                url:`${INVITATIONS}/allowed-roles`,
                method:'GET'
            })
        }),
        getPendingApprovals:builder.query({
            query:(params)=>{
                const searchParams = new URLSearchParams();
                if (params?.page) searchParams.append('page', params.page);
                if (params?.limit) searchParams.append('limit', params.limit);
                if (params?.search) searchParams.append('search', params.search);
                if (params?.role_id) searchParams.append('role_id', params.role_id);
                if (params?.status) searchParams.append('status', params.status);
                const qs = searchParams.toString();
                return {
                    url:`${INVITATIONS}/pending-approvals${qs ? `?${qs}` : ''}`,
                    method:'GET'
                };
            },
            providesTags:['PendingApprovals']
        }),
        getApprovalKpis:builder.query({
            query:()=>({
                url:`${INVITATIONS}/summary-kpis`,
                method:'GET'
            }),
            providesTags:['PendingApprovals']
        }),
        getReviewDetail:builder.query({
            query:(id)=>({
                url:`${INVITATIONS}/${id}/review-detail`,
                method:'GET'
            })
        }),
        approveInvitation:builder.mutation({
            query:({ id, remarks })=>({
                url:`${INVITATIONS}/${id}/approve`,
                method:'POST',
                body:{ remarks }
            }),
            invalidatesTags:['PendingApprovals', 'Invitations', 'UserManagementSummary', 'Users']
        }),
        rejectInvitation:builder.mutation({
            query:({ id, rejection_reason, remarks })=>({
                url:`${INVITATIONS}/${id}/reject`,
                method:'POST',
                body:{ rejection_reason: rejection_reason || remarks, remarks }
            }),
            invalidatesTags:['PendingApprovals', 'Invitations', 'UserManagementSummary']
        }),
        getMyPermissions:builder.query({
            query:()=>({
                url:`${PERMISSIONS}/me`,
                method:'GET'
            }),
            providesTags:['Permissions']
        }),
        getPermissionMatrix:builder.query({
            query:()=>({
                url:`${ADMIN_PERMISSIONS}/matrix`,
                method:'GET'
            }),
            providesTags:['RolePermissions', 'AdminModules']
        }),
        updatePermissionMatrix:builder.mutation({
            query:(body)=>({
                url:`${ADMIN_PERMISSIONS}/matrix`,
                method:'PUT',
                body
            }),
            invalidatesTags:['RolePermissions', 'UserPermissions', 'Permissions', 'PermissionAuditLogs']
        }),
        getAdminModules:builder.query({
            query:()=>({
                url:`${ADMIN_PERMISSIONS}/modules`,
                method:'GET'
            }),
            providesTags:['AdminModules']
        }),
        updateModuleStatus:builder.mutation({
            query:({ id, ...body })=>({
                url:`${ADMIN_PERMISSIONS}/modules/${id}`,
                method:'PUT',
                body
            }),
            invalidatesTags:['AdminModules', 'RolePermissions', 'UserPermissions', 'Permissions']
        }),
        getRolePermissions:builder.query({
            query:(roleId)=>({
                url:`${ADMIN_PERMISSIONS}/roles/${roleId}`,
                method:'GET'
            }),
            providesTags:['RolePermissions']
        }),
        updateRolePermission:builder.mutation({
            query:({ roleId, moduleId, ...body })=>({
                url:`${ADMIN_PERMISSIONS}/roles/${roleId}/modules/${moduleId}`,
                method:'PUT',
                body
            }),
            invalidatesTags:['RolePermissions', 'UserPermissions', 'Permissions', 'PermissionAuditLogs']
        }),
        enableAllRolePermissions:builder.mutation({
            query:({ roleId, ...body })=>({
                url:`${ADMIN_PERMISSIONS}/roles/${roleId}/modules/enable-all`,
                method:'PUT',
                body
            }),
            invalidatesTags:['RolePermissions', 'UserPermissions', 'Permissions', 'PermissionAuditLogs']
        }),
        disableAllRolePermissions:builder.mutation({
            query:({ roleId, ...body })=>({
                url:`${ADMIN_PERMISSIONS}/roles/${roleId}/modules/disable-all`,
                method:'PUT',
                body
            }),
            invalidatesTags:['RolePermissions', 'UserPermissions', 'Permissions', 'PermissionAuditLogs']
        }),
        getUserPermissionsDetail:builder.query({
            query:(userId)=>({
                url:`${ADMIN_PERMISSIONS}/users/${userId}`,
                method:'GET'
            }),
            providesTags:['UserPermissions']
        }),
        updateUserPermission:builder.mutation({
            query:({ userId, moduleId, ...body })=>({
                url:`${ADMIN_PERMISSIONS}/users/${userId}/modules/${moduleId}`,
                method:'PUT',
                body
            }),
            invalidatesTags:['UserPermissions', 'Permissions', 'PermissionAuditLogs']
        }),
        bulkUpdateUserPermissions:builder.mutation({
            query:({ userId, ...body })=>({
                url:`${ADMIN_PERMISSIONS}/users/${userId}/modules`,
                method:'PUT',
                body
            }),
            invalidatesTags:['UserPermissions', 'Permissions', 'PermissionAuditLogs']
        }),
        getPermissionAuditLogs:builder.query({
            query:(params)=>({
                url:`${ADMIN_PERMISSIONS}/audit-logs`,
                method:'GET',
                params
            }),
            providesTags:['PermissionAuditLogs']
        }),
        // QR PG User Endpoints
        getActiveQrConfig:builder.query({
            query:()=>({
                url:`${QR_PG}/config`,
                method:'GET'
            }),
            providesTags:['QrPgConfig']
        }),
        submitQrPayment:builder.mutation({
            query:(formData)=>({
                url:`${QR_PG}/transactions`,
                method:'POST',
                body:formData
            }),
            invalidatesTags:['QrPgTransactions', 'QrPgConfig', 'AdminQrPgTransactions']
        }),
        getMyQrTransactions:builder.query({
            query:(params)=>({
                url:`${QR_PG}/transactions`,
                method:'GET',
                params
            }),
            providesTags:['QrPgTransactions']
        }),
        getQrTransactionDetail:builder.query({
            query:(id)=>({
                url:`${QR_PG}/transactions/${id}`,
                method:'GET'
            }),
            providesTags:['QrPgTransactions']
        }),
        // QR PG Admin Endpoints
        adminGetQrConfigs:builder.query({
            query:()=>({
                url:`${ADMIN_QR_PG}/configs`,
                method:'GET'
            }),
            providesTags:['AdminQrPgConfigs']
        }),
        adminCreateQrConfig:builder.mutation({
            query:(formData)=>({
                url:`${ADMIN_QR_PG}/configs`,
                method:'POST',
                body:formData
            }),
            invalidatesTags:['AdminQrPgConfigs', 'QrPgConfig']
        }),
        adminUpdateQrConfig:builder.mutation({
            query:({ id, formData })=>({
                url:`${ADMIN_QR_PG}/configs/${id}`,
                method:'PUT',
                body:formData
            }),
            invalidatesTags:['AdminQrPgConfigs', 'QrPgConfig']
        }),
        adminActivateQrConfig:builder.mutation({
            query:(id)=>({
                url:`${ADMIN_QR_PG}/configs/${id}/activate`,
                method:'PUT'
            }),
            invalidatesTags:['AdminQrPgConfigs', 'QrPgConfig']
        }),
        adminDeactivateQrConfig:builder.mutation({
            query:(id)=>({
                url:`${ADMIN_QR_PG}/configs/${id}/deactivate`,
                method:'PUT'
            }),
            invalidatesTags:['AdminQrPgConfigs', 'QrPgConfig']
        }),
        adminDeleteQrConfig:builder.mutation({
            query:(id)=>({
                url:`${ADMIN_QR_PG}/configs/${id}`,
                method:'DELETE'
            }),
            invalidatesTags:['AdminQrPgConfigs', 'QrPgConfig']
        }),
        adminSyncAdcQrs: builder.mutation({
            query: () => ({
                url: `${ADMIN_QR_PG}/adc/sync-qrs`,
                method: 'POST'
            }),
            invalidatesTags: ['AdminQrPgConfigs', 'QrPgConfig']
        }),
        adminGetAdcBalance: builder.query({
            query: () => ({
                url: `${ADMIN_QR_PG}/adc/balance`,
                method: 'GET'
            })
        }),
        adminGetQrTransactions: builder.query({
            query: (params = {}) => {
                const qs = new URLSearchParams();
                if (params.page) qs.append('page', params.page);
                if (params.limit) qs.append('limit', params.limit);
                if (params.status && params.status !== 'ALL') qs.append('status', params.status);
                if (params.search) qs.append('search', params.search);
                if (params.qr_config_id && params.qr_config_id !== 'ALL') qs.append('qr_config_id', params.qr_config_id);
                if (params.role_id && params.role_id !== 'ALL') qs.append('role_id', params.role_id);
                if (params.startDate) qs.append('startDate', params.startDate);
                if (params.endDate) qs.append('endDate', params.endDate);
                if (params._t) qs.append('_t', params._t);
                const queryString = qs.toString();
                return {
                    url: `${ADMIN_QR_PG}/transactions${queryString ? `?${queryString}` : ''}`,
                    method: 'GET'
                };
            },
            providesTags: ['AdminQrPgTransactions']
        }),
        adminUpdateQrTransaction: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `${ADMIN_QR_PG}/transactions/${id}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: ['AdminQrPgTransactions', 'QrPgTransactions', 'QrPgConfig', 'Permissions', 'PermissionAuditLogs']
        }),
        adminApproveQrTransaction:builder.mutation({
            query:(arg)=> {
                const id = typeof arg === 'object' ? arg.id : arg;
                const body = typeof arg === 'object' ? arg : undefined;
                return {
                    url:`${ADMIN_QR_PG}/transactions/${id}/approve`,
                    method:'PUT',
                    body
                };
            },
            invalidatesTags:['AdminQrPgTransactions', 'QrPgTransactions', 'QrPgConfig', 'Permissions', 'PermissionAuditLogs']
        }),
        adminRejectQrTransaction:builder.mutation({
            query:({ id, ...body })=>({
                url:`${ADMIN_QR_PG}/transactions/${id}/reject`,
                method:'PUT',
                body
            }),
            invalidatesTags:['AdminQrPgTransactions', 'QrPgTransactions', 'QrPgConfig', 'PermissionAuditLogs']
        }),
        getDashboard: builder.query({
            query: () => ({
                url: `${DASHBOARD}/`,
                method: "GET"
            }),
            providesTags: ['Dashboard']
        }),
        requestSettlement: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/request`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Settlements', 'Wallet', 'Dashboard']
        }),
        getMySettlements: builder.query({
            query: (params) => ({
                url: `${SETTLEMENTS}/my`,
                method: "GET",
                params
            }),
            providesTags: ['Settlements']
        }),
        adminGetSettlements: builder.query({
            query: (params = {}) => {
                const qs = new URLSearchParams();
                if (params.page) qs.append('page', params.page);
                if (params.limit) qs.append('limit', params.limit);
                if (params.status && params.status !== 'ALL') qs.append('status', params.status);
                if (params.search) qs.append('search', params.search);
                if (params.startDate) qs.append('startDate', params.startDate);
                if (params.endDate) qs.append('endDate', params.endDate);
                if (params.user_id && params.user_id !== 'ALL') qs.append('user_id', params.user_id);
                if (params._t) qs.append('_t', params._t);
                const queryString = qs.toString();
                return {
                    url: `${SETTLEMENTS}/admin/list${queryString ? `?${queryString}` : ''}`,
                    method: "GET"
                };
            },
            providesTags: ['Settlements']
        }),
        adminRejectSettlement: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${SETTLEMENTS}/${id}/reject`,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['Settlements', 'Dashboard']
        }),
        checkPayoutStatus: builder.mutation({
            query: ({ orderid }) => ({
                url: `${API_BASE}/payouts/check-status/${orderid}`,
                method: "POST"
            }),
            invalidatesTags: ['Settlements', 'Wallet', 'Dashboard']
        }),
        togglePayoutService: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/admin/toggle-payout-service`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Settlements', 'SystemSettings', 'PayoutConfig']
        }),
        getPayoutServiceStatus: builder.query({
            query: () => ({
                url: `${SETTLEMENTS}/admin/payout-service-status`,
                method: "GET"
            }),
            providesTags: ['Settlements', 'SystemSettings']
        }),
        getGmaxPayoutBalance: builder.query({
            query: () => ({
                url: `${SETTLEMENTS}/admin/gmax-balance`,
                method: "GET"
            }),
            providesTags: ['Settlements', 'GmaxPayoutBalance']
        }),
        getPayout2Config: builder.query({
            query: () => ({
                url: `${SETTLEMENTS}/payout2-config`,
                method: "GET"
            }),
            providesTags: ['Settlements', 'Payout2Config']
        }),
        togglePayout2Service: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/toggle-payout2`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Settlements', 'Payout2Config']
        }),
        updatePayout2Charges: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/payout2-charges`,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['Settlements', 'Payout2Config']
        }),
        getMpaymentBalance: builder.query({
            query: () => ({
                url: `${SETTLEMENTS}/mpayment-balance`,
                method: "GET"
            }),
            providesTags: ['Settlements', 'MpaymentBalance']
        }),
        getFloatThresholds: builder.query({
            query: () => ({
                url: `${SETTLEMENTS}/float-thresholds`,
                method: "GET"
            }),
            providesTags: ['FloatThresholds']
        }),
        updateFloatThresholds: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/float-thresholds`,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['FloatThresholds', 'Settlements', 'GmaxPayoutBalance', 'MpaymentBalance']
        }),
        checkPayoutFloat: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/check-float`,
                method: "POST",
                body: data
            })
        }),
        verifyBankAccount: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/verify-bank-account`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Wallet', 'Dashboard', 'SavedBankAccounts']
        }),
        getSavedBankAccounts: builder.query({
            query: () => ({
                url: `${SETTLEMENTS}/saved-bank-accounts`,
                method: "GET"
            }),
            providesTags: ['SavedBankAccounts']
        }),
        deleteSavedBankAccount: builder.mutation({
            query: (id) => ({
                url: `${SETTLEMENTS}/saved-bank-accounts/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ['SavedBankAccounts']
        }),
        getNotifications: builder.query({
            query: () => ({
                url: `${NOTIFICATIONS}`,
                method: "GET"
            }),
            providesTags: ['Notifications']
        }),
        adminCreateNotification: builder.mutation({
            query: (data) => ({
                url: `${NOTIFICATIONS}/admin`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Notifications']
        }),
        adminDeactivateNotification: builder.mutation({
            query: (id) => ({
                url: `${NOTIFICATIONS}/admin/${id}/deactivate`,
                method: "PUT"
            }),
            invalidatesTags: ['Notifications']
        }),
        adminDeleteNotification: builder.mutation({
            query: (id) => ({
                url: `${NOTIFICATIONS}/admin/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ['Notifications']
        }),
        adminGetNotifications: builder.query({
            query: (params) => ({
                url: `${NOTIFICATIONS}/admin/admin-list`,
                method: "GET",
                params
            }),
            providesTags: ['Notifications']
        }),
        getNotificationSubscribers: builder.query({
            query: (params) => ({
                url: `${NOTIFICATIONS}/subscribers`,
                method: "GET",
                params
            }),
            providesTags: ['NotificationSubscribers']
        }),
        createNotificationSubscriber: builder.mutation({
            query: (data) => ({
                url: `${NOTIFICATIONS}/subscribers`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['NotificationSubscribers']
        }),
        updateNotificationSubscriber: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${NOTIFICATIONS}/subscribers/${id}`,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['NotificationSubscribers']
        }),
        deleteNotificationSubscriber: builder.mutation({
            query: (id) => ({
                url: `${NOTIFICATIONS}/subscribers/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ['NotificationSubscribers']
        }),
        getNotificationTemplates: builder.query({
            query: () => ({
                url: `${NOTIFICATIONS}/templates`,
                method: "GET"
            }),
            providesTags: ['NotificationTemplates']
        }),
        updateNotificationTemplate: builder.mutation({
            query: ({ triggerKey, ...data }) => ({
                url: `${NOTIFICATIONS}/templates/${triggerKey}`,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['NotificationTemplates']
        }),
        getUserNotificationsInbox: builder.query({
            query: (params) => ({
                url: `${NOTIFICATIONS}/user/inbox`,
                method: "GET",
                params
            }),
            providesTags: ['UserNotifications']
        }),
        getUserUnreadNotificationCount: builder.query({
            query: () => ({
                url: `${NOTIFICATIONS}/user/unread-count`,
                method: "GET"
            }),
            providesTags: ['UserNotificationsCount']
        }),
        markNotificationAsRead: builder.mutation({
            query: (id) => ({
                url: `${NOTIFICATIONS}/user/read/${id}`,
                method: "PATCH"
            }),
            invalidatesTags: ['UserNotifications', 'UserNotificationsCount']
        }),
        markAllNotificationsAsRead: builder.mutation({
            query: () => ({
                url: `${NOTIFICATIONS}/user/mark-all-read`,
                method: "PATCH"
            }),
            invalidatesTags: ['UserNotifications', 'UserNotificationsCount']
        }),
        getSystemSettings: builder.query({
            query: () => ({
                url: `${SETTINGS}`,
                method: "GET"
            }),
            providesTags: ['SystemSettings']
        }),
        updateSystemSettings: builder.mutation({
            query: (data) => ({
                url: `${SETTINGS}`,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['SystemSettings']
        }),
        getRetailerCommissionChain: builder.query({
            query: ({ userId, gatewayCode = 'ALL' }) => `${COMMISSIONS}/retailer-chain/${userId}?gateway_code=${gatewayCode}`,
            providesTags: ['Commissions']
        }),
        getMemberCommissionDetail: builder.query({
            query: ({ userId, gatewayCode = 'ALL' }) => `${COMMISSIONS}/member-detail/${userId}?gateway_code=${gatewayCode}`,
            providesTags: ['Commissions']
        }),
        getSdScenarios: builder.query({
            query: ({ userId, gatewayCode = 'ALL' }) => `${COMMISSIONS}/sd-scenarios/${userId}?gateway_code=${gatewayCode}`,
            providesTags: ['Commissions']
        }),
        saveSdScenarios: builder.mutation({
            query: (data) => ({
                url: `${COMMISSIONS}/sd-scenarios`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Commissions']
        }),
        getCommissionAllUsers: builder.query({
            query: () => `${COMMISSIONS}/retailers?all=true`,
            providesTags: ['UserManagement']
        }),
        getFinalMdrAudit: builder.query({
            query: ({ gatewayCode = 'ALL', superDistId = '', roleId = '', search = '' } = {}) => {
                const params = new URLSearchParams();
                if (gatewayCode && gatewayCode !== 'undefined') params.append('gateway_code', gatewayCode);
                if (superDistId && superDistId !== 'undefined' && superDistId !== 'null') params.append('super_dist_id', superDistId);
                if (roleId && roleId !== 'undefined' && roleId !== 'null') params.append('role_id', roleId);
                if (search && search.trim() && search !== 'undefined') params.append('search', search.trim());
                return `${COMMISSIONS}/final-mdr-audit?${params.toString()}`;
            },
            providesTags: ['Commissions']
        }),
        removeCommissionOverride: builder.mutation({
            query: ({ userId, gatewayCode = 'ALL', overrideMode = '' }) => ({
                url: `${COMMISSIONS}/override/${userId}?gateway_code=${gatewayCode}${overrideMode ? `&override_mode=${overrideMode}` : ''}`,
                method: "DELETE"
            }),
            invalidatesTags: ['Commissions', 'UserManagement']
        }),
        uploadBankStatement: builder.mutation({
            query: (formData) => ({
                url: '/admin/qr-pg/reconciliation/upload',
                method: 'POST',
                body: formData
            }),
            invalidatesTags: ['Reconciliation', 'QrPg']
        }),
        getReconciliationHistory: builder.query({
            query: () => '/admin/qr-pg/reconciliation/history',
            providesTags: ['Reconciliation']
        }),
        getReconciliationResults: builder.query({
            query: ({ statementId, status = 'ALL', search = '' }) =>
                `/admin/qr-pg/reconciliation/${statementId}?status=${status}&search=${encodeURIComponent(search)}`,
            providesTags: ['Reconciliation']
        }),
        approveReconciliation: builder.mutation({
            query: ({ reconciliationId, manualReason }) => ({
                url: `/admin/qr-pg/reconciliation/${reconciliationId}/approve`,
                method: 'POST',
                body: { manualReason }
            }),
            invalidatesTags: ['Reconciliation', 'QrPg', 'Commissions']
        }),
        bulkApproveReconciliation: builder.mutation({
            query: (reconciliationIds) => ({
                url: '/admin/qr-pg/reconciliation/bulk-approve',
                method: 'POST',
                body: { reconciliationIds }
            }),
            invalidatesTags: ['Reconciliation', 'QrPg', 'Commissions']
        }),
        rejectReconciliation: builder.mutation({
            query: ({ reconciliationId, reason }) => ({
                url: `/admin/qr-pg/reconciliation/${reconciliationId}/reject`,
                method: 'POST',
                body: { reason }
            }),
            invalidatesTags: ['Reconciliation', 'QrPg']
        }),
        deleteBankStatement: builder.mutation({
            query: (statementId) => ({
                url: `/admin/qr-pg/reconciliation/history/${statementId}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Reconciliation', 'QrPg']
        }),
        requestCommissionWithdrawal: builder.mutation({
            query: (data) => ({
                url: '/commission-withdrawals/request',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Commissions']
        }),
        getMyCommissionWithdrawals: builder.query({
            query: () => '/commission-withdrawals/my-requests',
            providesTags: ['Commissions']
        }),
        adminGetCommissionWithdrawals: builder.query({
            query: (params) => ({
                url: '/commission-withdrawals/admin/requests',
                params
            }),
            providesTags: ['Commissions']
        }),
        adminApproveCommissionWithdrawal: builder.mutation({
            query: (data) => {
                const reqId = data?.id || data?.request_id;
                const remarks = data?.remarks || data?.admin_remarks || data?.transaction_ref || "";
                return {
                    url: `/commission-withdrawals/admin/requests/${reqId}/approve`,
                    method: 'PUT',
                    body: { remarks, admin_remarks: remarks, request_id: reqId }
                };
            },
            invalidatesTags: ['Commissions']
        }),
        adminRejectCommissionWithdrawal: builder.mutation({
            query: (data) => {
                const reqId = data?.id || data?.request_id;
                const reason = data?.reason || data?.rejection_reason || "";
                return {
                    url: `/commission-withdrawals/admin/requests/${reqId}/reject`,
                    method: 'PUT',
                    body: { reason, rejection_reason: reason, request_id: reqId }
                };
            },
            invalidatesTags: ['Commissions']
        }),
        adjustCommissionBalance: builder.mutation({
            query: (data) => ({
                url: '/commission-withdrawals/admin/adjust-balance',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Commissions']
        }),
        getPayoutConfig: builder.query({
            query: () => `${SETTLEMENTS}/config`,
            providesTags: ['PayoutConfig']
        }),
        updatePayoutConfig: builder.mutation({
            query: (data) => ({
                url: `${SETTLEMENTS}/config`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['PayoutConfig']
        }),
        getPayinConfig: builder.query({
            query: () => ({
                url: `${PAYMENTS}/payin/config`,
                method: 'GET'
            })
        }),
        createPayinOrder: builder.mutation({
            query: (data) => ({
                url: `${PAYMENTS}/payin/create-order`,
                method: 'POST',
                body: data
            })
        }),
        verifyCashfreeStatus: builder.mutation({
            query: (data) => ({
                url: `${PAYMENTS}/payment-status`,
                method: 'POST',
                body: data
            })
        }),
        getPayinHistory: builder.query({
            query: (params) => {
                const qs = new URLSearchParams();
                if (params?.limit) qs.append('limit', params.limit);
                if (params?.user_id) qs.append('user_id', params.user_id);
                if (params?.all_users) qs.append('all_users', params.all_users);
                if (params?.exclude_c2b) qs.append('exclude_c2b', params.exclude_c2b);
                if (params?.startDate) qs.append('startDate', params.startDate);
                if (params?.endDate) qs.append('endDate', params.endDate);
                if (params?.search) qs.append('search', params.search);
                if (params?.status) qs.append('status', params.status);
                if (params?._t) qs.append('_t', params._t);
                return {
                    url: `${PAYMENTS}/payin-history${qs.toString() ? `?${qs.toString()}` : ''}`,
                    method: 'GET'
                };
            },
            providesTags: ['PayinHistory']
        }),
        syncPayinOrderStatus: builder.mutation({
            query: (data) => ({
                url: `${PAYMENTS}/sync-order-status`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['PayinHistory']
        }),
        getCardToBankAdminConfig: builder.query({
            query: () => ({
                url: `${CARD_TO_BANK}/admin/config`,
                method: 'GET'
            }),
            providesTags: ['CardToBankConfig']
        }),
        updateCardToBankPlatformSettings: builder.mutation({
            query: (data) => ({
                url: `${CARD_TO_BANK}/admin/platform-settings`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['CardToBankConfig', 'CardToBankFeeStructure']
        }),
        addCardToBankCategory: builder.mutation({
            query: (data) => ({
                url: `${CARD_TO_BANK}/admin/categories`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['CardToBankConfig', 'CardToBankCategories']
        }),
        updateCardToBankCategory: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${CARD_TO_BANK}/admin/categories/${id}`,
                method: 'PUT',
                body: data
            }),
            async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
                const patchAdmin = dispatch(
                    usersApiSlice.util.updateQueryData('getCardToBankAdminConfig', undefined, (draft) => {
                        const cat = draft?.categories?.find((c) => Number(c.id) === Number(id));
                        if (cat) {
                            Object.assign(cat, patch);
                        }
                    })
                );
                const patchPublic = dispatch(
                    usersApiSlice.util.updateQueryData('getCardToBankCategories', undefined, (draft) => {
                        if (!draft?.categories) return;
                        if (patch.status === 'disabled') {
                            draft.categories = draft.categories.filter((c) => Number(c.id) !== Number(id));
                        } else {
                            const cat = draft.categories.find((c) => Number(c.id) === Number(id));
                            if (cat) {
                                Object.assign(cat, patch);
                            }
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchAdmin.undo();
                    patchPublic.undo();
                }
            },
            invalidatesTags: ['CardToBankCategories']
        }),
        deleteCardToBankCategory: builder.mutation({
            query: (id) => ({
                url: `${CARD_TO_BANK}/admin/categories/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['CardToBankConfig', 'CardToBankCategories']
        }),
        addCardToBankSlab: builder.mutation({
            query: (data) => ({
                url: `${CARD_TO_BANK}/admin/slabs`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['CardToBankConfig', 'CardToBankFeeStructure']
        }),
        deleteCardToBankSlab: builder.mutation({
            query: (id) => ({
                url: `${CARD_TO_BANK}/admin/slabs/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['CardToBankConfig', 'CardToBankFeeStructure']
        }),
        syncCardToBankBalance: builder.mutation({
            query: () => ({
                url: `${CARD_TO_BANK}/admin/sync-balance`,
                method: 'GET'
            }),
            invalidatesTags: ['CardToBankConfig']
        }),
        getCardToBankCategories: builder.query({
            query: () => ({
                url: `${CARD_TO_BANK}/categories`,
                method: 'GET'
            }),
            providesTags: ['CardToBankCategories']
        }),
        getCardToBankFeeStructure: builder.query({
            query: () => ({
                url: `${CARD_TO_BANK}/fee-structure`,
                method: 'GET'
            }),
            providesTags: ['CardToBankFeeStructure']
        }),
        calculateCardToBankFee: builder.mutation({
            query: (data) => ({
                url: `${CARD_TO_BANK}/calculate`,
                method: 'POST',
                body: data
            })
        }),
        initiateCardToBankPayment: builder.mutation({
            query: (data) => ({
                url: `${CARD_TO_BANK}/initiate`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['CardToBankHistory']
        }),
        getCardToBankHistory: builder.query({
            query: (params) => {
                const qs = new URLSearchParams(params || {});
                return {
                    url: `${CARD_TO_BANK}/history?${qs.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: ['CardToBankHistory']
        }),
        syncCardToBankOrderStatus: builder.mutation({
            query: (data) => ({
                url: `${CARD_TO_BANK}/check-status`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['CardToBankHistory', 'PayinHistory']
        }),
        syncAllCardToBankOrders: builder.mutation({
            query: () => ({
                url: `${CARD_TO_BANK}/admin/sync-all`,
                method: 'POST'
            }),
            invalidatesTags: ['CardToBankHistory', 'PayinHistory']
        })
    })
})

export const {
    useGetDashboardQuery,
    useLoginMutation,
    useCheckUserMutation,
    useSetPasswordMutation,
    useResetPasswordWithFirebaseMutation,
    useAccepTermsMutation,
    useLogoutMutation,
    useUpdateUserMutation,
    useChangePasswordMutation,
    useGetUserQuery,
    useGetDistributorMutation,
    useCreateDistributorMutation,
    useGetDistributorDetailsMutation,
    useUpdateDistributorMarginMutation,
    useUpdateDistributorMutation,
    useActivateDistributorMutation,
    useGetRetailerMutation,
    useCreateRetailerMutation,
    useApproveDistributorMutation,
    useGetRetailerDetailsMutation,
    useUpdateRetailerMutation,
    useApproveRetailerMutation,
    useUpdateRetailerPercentageMutation,
    useActiveRetailerMutation,
    useOrderStatusMutation,
    useOrderHistoryMutation,
    useRetailerMutation,
    useAadharMutation,
    useOtpMutation,
    usePanMutation,
    useContactMutation,
    useVerifyMutation,
    useResetPasswordMutation,
    useGstMutation,
    useGetSuperDistributorMutation,
    useCreateSuperDistributorMutation,
    useGetSuperDistributorDetailsMutation,
    useUpdateSuperDistributorMutation,
    useActivateSuperDistributorMutation,
    useApproveSuperDistributorMutation,
    useGetReporterMutation,
    useCreateReporterMutation,
    useApiLockMutation,
    useGetGateWaysMutation,
    useCreateGateWaysMutation,
    useToggleGateWayStatusMutation,
    useUpdateGateWayConfigMutation,
    useDeleteGateWayMutation,
    useGetUserManagementSummaryQuery,
    useGetUserManagementListMutation,
    useGetUserManagementDetailQuery,
    useUpdateUserStatusMutation,
    useEditUserInHierarchyMutation,
    useAdjustUserBalanceMutation,
    useResetUserPasswordInHierarchyMutation,
    useResetUserLoginCounterMutation,
    useToggleUserWalletStatusMutation,
    useGetCommissionGatewaysQuery,
    useGetCommissionMembersQuery,
    useGetCommissionRulesQuery,
    useUpdateCommissionRuleMutation,
    useGetUserOverrideQuery,
    useSaveUserOverrideMutation,
    useGetOverrideHistoryQuery,
    useRestoreOverrideHistoryMutation,
    useGetTodayTransactionsQuery,
    useSendInvitationMutation,
    useGetMyInvitationsQuery,
    useResendInvitationMutation,
    useGetPendingApprovalsQuery,
    useGetApprovalKpisQuery,
    useGetReviewDetailQuery,
    useApproveInvitationMutation,
    useRejectInvitationMutation,
    useGetMyPermissionsQuery,
    useGetPermissionMatrixQuery,
    useUpdatePermissionMatrixMutation,
    useGetAdminModulesQuery,
    useUpdateModuleStatusMutation,
    useGetRolePermissionsQuery,
    useUpdateRolePermissionMutation,
    useEnableAllRolePermissionsMutation,
    useDisableAllRolePermissionsMutation,
    useGetUserPermissionsDetailQuery,
    useBulkUpdateUserPermissionsMutation,
    useGetPermissionAuditLogsQuery,
    useGetActiveQrConfigQuery,
    useSubmitQrPaymentMutation,
    useGetMyQrTransactionsQuery,
    useAdminGetQrConfigsQuery,
    useAdminCreateQrConfigMutation,
    useAdminUpdateQrConfigMutation,
    useAdminActivateQrConfigMutation,
    useAdminDeactivateQrConfigMutation,
    useAdminDeleteQrConfigMutation,
    useAdminSyncAdcQrsMutation,
    useAdminGetAdcBalanceQuery,
    useAdminGetQrTransactionsQuery,
    useAdminApproveQrTransactionMutation,
    useAdminRejectQrTransactionMutation,
    useAdminUpdateQrTransactionMutation,
    useRequestSettlementMutation,
    useGetMySettlementsQuery,
    useAdminGetSettlementsQuery,
    useAdminRejectSettlementMutation,
    useCheckPayoutStatusMutation,
    useTogglePayoutServiceMutation,
    useGetPayoutServiceStatusQuery,
    useGetGmaxPayoutBalanceQuery,
    useGetPayout2ConfigQuery,
    useTogglePayout2ServiceMutation,
    useUpdatePayout2ChargesMutation,
    useGetMpaymentBalanceQuery,
    useGetFloatThresholdsQuery,
    useUpdateFloatThresholdsMutation,
    useCheckPayoutFloatMutation,
    useVerifyBankAccountMutation,
    useGetSavedBankAccountsQuery,
    useDeleteSavedBankAccountMutation,
    useGetPayoutConfigQuery,
    useUpdatePayoutConfigMutation,
    useGetNotificationsQuery,
    useAdminCreateNotificationMutation,
    useAdminDeactivateNotificationMutation,
    useAdminDeleteNotificationMutation,
    useAdminGetNotificationsQuery,
    useGetNotificationSubscribersQuery,
    useCreateNotificationSubscriberMutation,
    useUpdateNotificationSubscriberMutation,
    useDeleteNotificationSubscriberMutation,
    useGetNotificationTemplatesQuery,
    useUpdateNotificationTemplateMutation,
    useGetUserNotificationsInboxQuery,
    useGetUserUnreadNotificationCountQuery,
    useMarkNotificationAsReadMutation,
    useMarkAllNotificationsAsReadMutation,
    useGetSystemSettingsQuery,
    useUpdateSystemSettingsMutation,
    useRequestCommissionWithdrawalMutation,
    useGetMyCommissionWithdrawalsQuery,
    useAdminGetCommissionWithdrawalsQuery,
    useAdminApproveCommissionWithdrawalMutation,
    useAdminRejectCommissionWithdrawalMutation,
    useAdjustCommissionBalanceMutation,
    useGetRetailerCommissionChainQuery,
    useGetSdScenariosQuery,
    useSaveSdScenariosMutation,
    useGetCommissionAllUsersQuery,
    useGetFinalMdrAuditQuery,
    useRemoveCommissionOverrideMutation,
    useUploadBankStatementMutation,
    useGetReconciliationHistoryQuery,
    useGetReconciliationResultsQuery,
    useApproveReconciliationMutation,
    useBulkApproveReconciliationMutation,
    useRejectReconciliationMutation,
    useDeleteBankStatementMutation,
    useGetPayinConfigQuery,
    useCreatePayinOrderMutation,
    useVerifyCashfreeStatusMutation,
    useGetPayinHistoryQuery,
    useSyncPayinOrderStatusMutation,
    useGetCardToBankAdminConfigQuery,
    useUpdateCardToBankPlatformSettingsMutation,
    useAddCardToBankCategoryMutation,
    useUpdateCardToBankCategoryMutation,
    useDeleteCardToBankCategoryMutation,
    useAddCardToBankSlabMutation,
    useDeleteCardToBankSlabMutation,
    useSyncCardToBankBalanceMutation,
    useGetCardToBankCategoriesQuery,
    useCalculateCardToBankFeeMutation,
    useInitiateCardToBankPaymentMutation,
    useGetCardToBankHistoryQuery,
    useSyncCardToBankOrderStatusMutation,
    useSyncAllCardToBankOrdersMutation,
    useRefreshSessionMutation,
    useGetSessionConfigQuery,
    // Lazy query hooks for full exports
    useLazyAdminGetSettlementsQuery,
    useLazyAdminGetQrTransactionsQuery,
    useLazyGetPayinHistoryQuery,
    useLazyGetCardToBankHistoryQuery
} = usersApiSlice;
